/**
 *
 * Asynchronously loads the component for MobileSupport
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MobileSupport = lazyLoad(
  () => import('./index'),
  module => module.MobileSupport,
);
